define('lq/actionLoader',[
    'lq',
    'jquery',
    'underscore',
    'lq/stylesheets',
    'lq/ajax',
    'lq/runtimeDispatcher'
], function (lq, $, _, stylesheets, ajax, RuntimeDispatcher) {

    var ActionLoader = function (url) {
        this.url = url;
        this.requestId = 0;
        this.listeners = [];
    };

    ActionLoader.prototype.addListener = function (callback) {
        this.listeners.push(callback);
    };

    ActionLoader.prototype.removeListener = function (callback) {
        var index = this.listeners.indexOf(callback);
        if (index >= 0)
            this.listeners.splice(index, 1);
    };

    ActionLoader.prototype.load = function (actionId, globals, locals, state, insertionPoints) {
        this.requestId += 1;

        const options = {
            type: 'POST',
            url: this.url.prepare(lq.getTenantUrl('LicquidAction/Navigate')),
            cache: false,
            data: JSON.stringify({
                id: actionId,
                insertionPoints: insertionPoints
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            error: function(jqxhr) {
                if (jqxhr && jqxhr.status === 401)
                    window.location.reload();
            }
        };

        ajax.withRetry(RuntimeDispatcher.protectRequest(options)).then(async function(data) {
            if(data.view) await stylesheets.loadFor(data.view.actions);
            return data;
        }).then(this.receivedData.bind(this, actionId, globals, locals, state, this.requestId));
    };

    ActionLoader.prototype.receivedData = function (actionId, globals, locals, state, requestId, data) {
        if (requestId !== this.requestId) return;

        if (data.requiresLogin) {
            // force a redirect to make sure we don't keep any in-memory state of a previous user

            var pageUrl = 'LicquidAction/Get/' + actionId;

            var parameters = {};
            if (_.keys(globals).length)
                parameters.globals = JSON.stringify(globals);
            if (_.keys(locals).length)
                parameters.parameters = JSON.stringify(locals);

            var currentUrl = this.url.prepare(lq.getTenantUrl(pageUrl), parameters);
            this.url.openUrl(currentUrl);
        } else {
            _.forEach(this.listeners, function (listener) {
                listener(
                    actionId,
                    data,
                    {
                        globals: globals,
                        locals: locals,
                        system: data.systemParameters
                    },
                    state);
            });
        }
    };

    return ActionLoader;

});
